import React from "react";
import './LegalPages.scss';


const TermsOfUse = () => (
  <div className="legal-page">
    <h1>Conditions Générales d’Utilisation</h1>
    <p>Dernière mise à jour : 7 août 2025</p>

    <h2>1. Objet</h2>
    <p>
      Les présentes CGU définissent les conditions d’utilisation du service ReviewBoost AI.
    </p>

    <h2>2. Fonctionnalités proposées</h2>
    <ul>
      <li>Collecte et gestion des avis clients</li>
      <li>Génération de réponses par intelligence artificielle</li>
      <li>Statistiques et alertes</li>
    </ul>

    <h2>3. Responsabilités de l’utilisateur</h2>
    <ul>
      <li>S’engager à ne pas poster de faux avis</li>
      <li>Vérifier et valider les réponses générées par IA avant publication</li>
      <li>Respecter la réglementation en vigueur</li>
    </ul>

    <h2>4. Responsabilités de ReviewBoost AI</h2>
    <ul>
      <li>Fournir un service conforme et sécurisé</li>
      <li>Informer sur tout incident majeur de sécurité</li>
    </ul>

    <h2>5. Propriété intellectuelle</h2>
    <p>
      Le contenu généré par l’IA appartient à l’utilisateur.<br />
      ReviewBoost AI ne revendique aucun droit sur les avis ou réponses.
    </p>

    <h2>6. Limitation de responsabilité</h2>
    <p>
      Le service est fourni « en l’état ». ReviewBoost AI décline toute responsabilité en cas de mauvaise utilisation, perte de données, ou dommages indirects.
    </p>

    <h2>7. Modification et interruption</h2>
    <p>
      Nous pouvons modifier ou interrompre tout ou partie du service avec préavis raisonnable.
    </p>

    <h2>8. Contact</h2>
    <p>
      Pour toute question : <strong>sbdev42@gmail.com</strong>
    </p>

    <h2>9. Droit applicable</h2>
    <p>
      Droit français. En cas de litige, compétence des tribunaux du ressort du siège social de ReviewBoost AI.
    </p>
  </div>
);

export default TermsOfUse;
